import React, { Component } from 'react';
import './App.css';
import { Link } from "react-router-dom";
import Jumbotron from 'react-bootstrap/Jumbotron';
import Button from 'react-bootstrap/Button';
import { LinkContainer } from 'react-router-bootstrap';
import Routes from "./Routes";

class App extends Component {

  constructor(props) {
    super(props);
    this.state = {
      score: 0,
      name: "",
      difficulty: 0
    };
  }

  render() {
    console.log(process.env);
    const childProps = this.state;
  
    return (
      <div className="App">
        <Routes childProps={childProps} /> {/* Passing child props to child components */}
      </div>
    );
  }
}

export default App;
